<template>
  <div>
    <b-card title="MiME TV Services">
      <b-table
        responsive
        striped
        bordered
        hover
        :items="mimeTvServices"
        :fields="fields"
        show-empty
        empty-text="No MiME TV service found"
      >
        <!-- SL -->
        <template #cell(sl)="data">
          {{ data.index + 1 }}
        </template>

        <!-- Service Type -->
        <template #cell(service_line_type)="data">
          {{ data.item.service_line_type }}
        </template>

        <!-- Service Name -->
        <template #cell(service_name)> MiME TV </template>

        <!-- Package Name -->
        <template #cell(name)="data">
          {{ data.item.name }}
        </template>

        <!-- Package Price -->
        <template #cell(price)="data">
          <span v-if="data.item.service_line_type !== 'Bundle'">
            {{ data.item.sub_total }} tk
          </span>
          <span v-else>-</span>
        </template>

        <!-- IPTV Username -->
        <template #cell(iptv_username)="data">
          {{ data.item.iptv_username }}
        </template>

        <!-- Valid From -->
        <template #cell(start_date_time)="data">
          {{ data.item.start_date_time }}
        </template>

        <!-- Valid To -->
        <template #cell(end_date_time)="data">
          {{ data.item.end_date_time }}
        </template>

        <!-- Installation Address -->
        <template #cell(installment_address)="data">
          {{ data.item.installment_address || "-" }}
        </template>

        <!-- Status -->
        <template #cell(status)="data">
          <span :class="data.item.status ? 'text-success' : 'text-danger'">
            {{ data.item.status ? "Active" : "Inactive" }}
          </span>
        </template>

        <!-- Billable -->
        <template #cell(billable)="data">
          <span :class="data.item.billable ? 'text-success' : 'text-danger'">
            {{ data.item.billable ? "Active" : "Inactive" }}
          </span>
        </template>

        <!-- Action -->
        <template #cell(action)="data">
          <b-button size="sm" variant="info" @click="openResendModal(data.item)">
            Resend Password
          </b-button>
        </template>
      </b-table>

            <!-- Confirmation Modal -->
      <b-modal
        id="resend-modal"
        title="Confirm Resend"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
      >
        <p>
          Are you sure you want to resend the password?
        </p>

        <div class="text-right">
          <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('resend-modal')">
            No
          </b-button>

          <b-button variant="warning" @click="confirmResend"> Yes </b-button>
        </div>
      </b-modal>
    </b-card>

    <div class="row">
      <div class="col-12 col-lg-6">
        <b-card>
          <div class="md">
            <h3 class="mt-10">How to Pay for MiME Internet from Selfcare</h3>
            <video class="responsive-video" width="100%" controls>
              <source :src="videoUrl" type="video/mp4" />
            </video>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { BCard, BTable, BButton } from "bootstrap-vue";
import api from "@/services/api";
import { decrypt } from "@/utils/crypto";

export default {
  components: {
    BCard,
    BTable,
    BButton,
  },

  data() {
    return {
      serviceLines: [],
      service_line_id: null,
      videoUrl: "/documents/How_to_Pay_for_MiME_Internet_from_Selfcare.mp4",
      fields: [
        { key: "sl", label: "#" },
        { key: "service_line_type", label: "Service Type" },
        { key: "service_name", label: "Service Name" },
        { key: "name", label: "Package Name" },
        { key: "price", label: "Package Price" },
        { key: "iptv_username", label: "MiME TV Username" },
        { key: "start_date_time", label: "Valid From" },
        { key: "end_date_time", label: "Valid To" },
        { key: "installment_address", label: "Installation Address" },
        { key: "status", label: "Status" },
        { key: "billable", label: "Billable" },
        { key: "action", label: "Action" },
      ],
    };
  },

  computed: {
    // Filter only mime-tv service
    mimeTvServices() {
      return this.serviceLines.filter((service) => service.service_type === "mime-tv");
    },
  },

  methods: {
    async fetchServiceLines() {
      const userData = decrypt(localStorage.getItem("userData"));
      const username = userData?.username;
      const loader = this.$showCustomLoader();
      try {
        const res = await api.get(
          `/selfcare/api/v1/customer/service-line/?username=${username}`
        );
        loader?.hide();
        this.serviceLines = res.data.package_line || [];
      } catch (error) {
        loader?.hide();
        console.error("Service line fetch failed:", error);
      }
    },

    openResendModal(item) {
      this.service_line_id = item.id;
      this.$bvModal.show("resend-modal");
    },

    
    // Confirm resend action
    async confirmResend() {
      const loader = this.$showCustomLoader();

      try {
        await api.post(
          "/api/v1/iptv_password_resend/",
          { service_line_id: this.service_line_id }
        );

        this.$bvToast.toast("Password resent successfully", {
          title: "Success",
          variant: "success",
          solid: true,
        });

        this.$bvModal.hide("resend-modal");
      } catch (error) {
        console.error("Resend password failed", error);

        this.$bvToast.toast("Failed to resend password", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        loader.hide();
      }
    },
  },

  mounted() {
    this.fetchServiceLines();
  },
};
</script>
<style scoped>
  .responsive-video {
    width: 100%;
    height: auto;
    max-width: 100%;
  }
</style>
